import React from 'react';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import {PersistGate} from 'redux-persist/integration/react';
import store, {persistor} from './store';
import Theme from 'components/template/Theme';
import Layout from 'components/layout';
import history from './history';
import appConfig from 'configs/app.config';
import './locales';
import ProviderContext from './provider/Provider';
import AppTourProvider from 'provider/TourProvider';
import Socket from 'provider/dloreanSocket';
const environment = process.env.NODE_ENV;

function App() {
  return (
    <ProviderContext>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Socket>
            <AppTourProvider>
              <BrowserRouter history={history}>
                <Theme>
                  <Layout />
                </Theme>
              </BrowserRouter>
            </AppTourProvider>
          </Socket>
        </PersistGate>
      </Provider>
    </ProviderContext>
  );
}

export default App;
